/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface PlageHoraireSearch
 */
export interface PlageHoraireSearch {
    /**
     * 
     * @type {number}
     * @memberof PlageHoraireSearch
     */
    idcentre?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof PlageHoraireSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof PlageHoraireSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof PlageHoraireSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PlageHoraireSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof PlageHoraireSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof PlageHoraireSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the PlageHoraireSearch interface.
 */
export function instanceOfPlageHoraireSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PlageHoraireSearchFromJSON(json: any): PlageHoraireSearch {
    return PlageHoraireSearchFromJSONTyped(json, false);
}

export function PlageHoraireSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlageHoraireSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idcentre': !exists(json, 'idcentre') ? undefined : json['idcentre'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function PlageHoraireSearchToJSON(value?: PlageHoraireSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idcentre': value.idcentre,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

